import { getLocalApi } from "./localApi";
import apiConfig from "app/api/apiConfig.json";

export interface CourseLanguageDto {
  id: number;
  name: string;
  createdBy: string;
  lastModifiedBy: string;
  active: boolean;
}

function mapCourseLanguage(dto: any): CourseLanguageDto {
  return {
    id: typeof dto?.id === "number" ? dto.id : Number(dto?.id) || 0,
    name: dto?.name ?? "",
    createdBy: dto?.createdBy ?? "",
    lastModifiedBy: dto?.lastModifiedBy ?? "",
    active: typeof dto?.isActive === "boolean" ? dto.isActive : !!dto?.active,
  };
}

export async function getAllCourseLanguages(): Promise<CourseLanguageDto[]> {
  const localApi = await getLocalApi();
  return await localApi.fetchList(
    (apiConfig as any).reference_data_get_course_languages,
    mapCourseLanguage,
    "Unable to fetch course languages"
  );
}